import { useMutation } from '@apollo/client';
import { Chip, Grid, Icon } from '@mui/material';
import { ConfirmationDialog } from 'app/components/ConfirmationDialog';

import { translations } from 'locales/i18n';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { actions as AlertActions } from 'app/containers/Dashboard/Alert/slice';
import './styles/EntitlementItem.scss';

import DELETE_MUTATION from 'gql/mutations/PermissionProvider/deleteEntitlement.gql';
interface Props {
  entitlement: any;
}

export const EntitlementItem: FunctionComponent<Props> = ({ entitlement }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [deleteEntitlement] = useMutation(DELETE_MUTATION);

  const handleDelete = async () => {
    try {
      await deleteEntitlement({
        variables: {
          id: entitlement.id
        },
        refetchQueries: ['GetEntitlements']
      });
      dispatch(
        AlertActions.success(
          t(translations.pages.managePermissionsSettings.alertsEntitlement.deleteSuccess())
        )
      );
    } catch (err) {
      dispatch(
        AlertActions.error(
          t(translations.pages.managePermissionsSettings.alertsEntitlement.deleteFailed())
        )
      );
    }
  };

  return (
    <Grid container className="entitlement">
      <Grid item xs={1} className="entitlement__id">
        {entitlement.id}
      </Grid>
      <Grid item xs={5} className="entitlement__name">
        {entitlement.entitlement}
      </Grid>
      <Grid item xs={5} className="entitlement__roles">
        {entitlement.groupRoles.length === 0 ? null : (
          <>
            {entitlement.groupRoles.length > 3 ? (
              <Grid container>
                {entitlement.groupRoles.slice(0, 3).map(role => (
                  <Chip
                    label={role.name}
                    className="entitlement__roles__item"
                    icon={
                      <Icon className={role.icon} style={{ width: '30px', marginLeft: '0.5em' }} />
                    }
                  />
                ))}
                <Chip
                  label={`+${entitlement.groupRoles.length - 3}`}
                  className="entitlement__roles__item"
                />
              </Grid>
            ) : (
              <Grid container>
                {entitlement.groupRoles.map(role => (
                  <Chip
                    className="entitlement__roles__item"
                    label={role.name}
                    icon={
                      <Icon className={role.icon} style={{ width: '30px', marginLeft: '0.5em' }} />
                    }
                  />
                ))}
              </Grid>
            )}
          </>
        )}
      </Grid>
      <Grid item xs={1} className="entitlement__actions">
        <div onClick={() => setDeleteModalOpen(true)}>
          <Icon className="fas fa-times entitlement__actions__delete" />
        </div>
      </Grid>
      <ConfirmationDialog
        open={deleteModalOpen}
        title={t(translations.pages.managePermissionsSettings.deleteModalEntitlment.title())}
        onClose={() => {
          setDeleteModalOpen(false);
        }}
        onConfirm={() => {
          handleDelete();
          setDeleteModalOpen(false);
        }}
      >
        <div>{t(translations.pages.managePermissionsSettings.deleteModalEntitlment.message())}</div>
      </ConfirmationDialog>
    </Grid>
  );
};
